/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Characters/Line" |
*
* @param {Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_characters_per_line_label = /** @type {((inputs?: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caracteres maximum par ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeichen pro Zeile")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di caratteri/riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество символов в строке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de caracteres/línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每行最大字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大文字数/行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति पंक्ति अधिकतम अक्षर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de caracteres por linha")
	return /** @type {LocalizedString} */ ("Maximum Characters/Line")
});